<template>
    <div class="wrapper ecommerce-page">
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/20171212_075219.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto">
                        <h1 class="title">PARTS + SUPPORT</h1>
                        <h3>Products to support your business</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="section">
                <div class="container">
                    <h2 class="section-title">Parts</h2>
                    <div class="row">
                        <div class="col-md-4">
                            <card type="product" plain>
                                <img slot="image" src="img/255.jpg" alt="">
                                <h4 class="card-title">
                                    <a href="#pablo">Danfoss Parts</a>
                                </h4>
                                <p class="card-description">We are a Danfoss Value Added Distributor providing Refrigeration and HVAC electronic control parts and service.</p>
                                <div class="card-footer">
                                    <!-- <div class="price-container">
                                        <span class="price price-old"> &euro;1,430</span>
                                        <span class="price price-new"> &euro;743</span>
                                    </div>
                                    <div class="stats stats-right">
                                        <el-tooltip content="Saved to Wishlist" effect="light" placement="top">
                                            <n-button type="neutral" icon>
                                                <i class="now-ui-icons ui-2_favourite-28"></i>
                                            </n-button>
                                        </el-tooltip>
                                    </div> -->
                                    <a href="#pablo" class="btn btn-primary btn-lg mr-3">
                                        View Parts
                                    </a>
                                </div>
                            </card>
                        </div>
                        <div class="col-md-4">
                            <card type="product" plain>
                                <img slot="image" src="img/legacyfeature.png" alt="">
                                <h4 class="card-title">
                                    <a href="#pablo">Legacy &amp; Obsolete Parts</a>
                                </h4>
                                <p class="card-description">We have the world’s largest inventory of all obsolete facility control parts. We are able to provide parts as well as remote and onsite support for all legacy equipment.</p>
                                <div class="card-footer">
                                    <!-- <div class="price-container">
                                        <span class="price price-old"> &euro;1,430</span>
                                        <span class="price price-new"> &euro;743</span>
                                    </div>
                                    <div class="stats stats-right">
                                        <el-tooltip content="Saved to Wishlist" effect="light" placement="top">
                                            <n-button type="neutral" icon>
                                                <i class="now-ui-icons ui-2_favourite-28"></i>
                                            </n-button>
                                        </el-tooltip>
                                    </div> -->
                                    <a href="#pablo" class="btn btn-primary btn-lg mr-3">
                                        View Parts
                                    </a>
                                </div>
                            </card>
                        </div>
                        <div class="col-md-4">
                            <card type="product" plain>
                                <img slot="image" src="img/partsfeatures.png" alt="">
                                <h4 class="card-title">
                                    <a href="#pablo">Sensors &amp; Transducers</a>
                                </h4>
                                <p class="card-description">We offer a wide range of quality American made Temperature Sensors and Pressure Transducers.</p>
                                <div class="card-footer">
                                    <!-- <div class="price-container">
                                        <span class="price price-old"> &euro;2,430</span>
                                        <span class="price price-new">&euro;890</span>
                                    </div>
                                    <div class="stats stats-right">
                                        <el-tooltip content="Saved to Wishlist" effect="light" placement="top">
                                            <n-button type="neutral" icon>
                                                <i class="now-ui-icons ui-2_favourite-28"></i>
                                            </n-button>
                                        </el-tooltip>
                                    </div> -->
                                    <a href="#pablo" class="btn btn-primary btn-lg mr-3">
                                        View Parts
                                    </a>
                                </div>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
            <!-- section -->
        </div>
        <!--     *********    CONTACT US 1     *********      -->
        <contact></contact>
        
        <!--     *********    END CONTACT US 1      *********      -->
    </div>
</template>
<script>
  import Contact from './components/Contact'
  import { Card, InfoSection } from '@/components';
  import { Carousel, CarouselItem, Tooltip } from 'element-ui'

  export default {
    name: 'presentation',
    bodyClass: 'presentation-page',
    components: {
      Contact,
      Card,
      InfoSection,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Tooltip.name]: Tooltip,
    },
  }
</script>
<style scoped>
@media (max-width: 768px){
        h1.title{
            font-size:5em;
        }
    }
    @media screen and (min-width: 991px){
        h1.title{
            font-size:7em;
        }
    }
    @media screen and (max-width: 576px){
        h1.title{
            font-size:3.5em;
        }
    }
    .card-footer{
        text-align: center;
    }
</style>